export const EMPTY_VALUE = '—';

export const DEFAULT_SORTS = [
  { field: 'context.status', dir: 1 },
  { field: 'context.create_dt', dir: -1 },
];

export const STATUS_DATE_SORTS = [
  { field: 'context.status', dir: 1 },
  { field: 'context.create_dt', dir: -1 },
];

export const SOURCE_DATE_SORTS = [
  { field: 'meta.service_name', dir: 1 },
  { field: 'context.create_dt', dir: -1 },
];

export const ROUTE_SORTS = [
  { field: 'route.departure.city_name', dir: 1 },
  { field: 'route.destination.city_name', dir: 1 },
];

export const BIDDING_STATES = [
  { value: 'PLAY', label: 'Торги', color: '#007bff' },
  { value: 'WON', label: 'Выиграна', color: '#28a745' },
  { value: 'LOST', label: 'Проиграна', color: '#dc3545' },
  { value: 'NOT_PARTICIPATED', label: 'Не участвовали', color: '#6c757d' },
  { value: 'ANNULLED', label: 'Аннулирована', color: '#868e96' },
  { value: 'CANCELED', label: 'Отменена', color: '#fd7e14' },
  { value: 'DELETED', label: 'Удалена', color: '#343a40' },
  { value: 'UNKNOWN', label: 'Неизвестно', color: '#adb5bd' },
  { value: 'DONE', label: 'Завершена', color: '#17a2b8' },
  { value: 'TENDER', label: 'Тендер', color: '#6f42c1' },
];

export const SOURCE_OPTIONS = [
  { value: 'efes', label: 'Efes' },
  { value: 'loginet', label: 'Loginet' },
  { value: 'trucker', label: 'Trucker' },
  { value: 'unitedbrew', label: 'ОПХ (прош.)' },
  { value: 'efko', label: 'Efko' },
  { value: 'artlogic', label: 'ArtLogic' },
  { value: 'docrobot', label: 'Docrobot' },
  { value: 'torgtrans', label: 'Torgtrans' },
  { value: 'brew4ru', label: 'ОПХ (нов.)' },
];

export const TASKED_OPTIONS = [
  { value: '', label: 'Все' },
  { value: 'active', label: 'С задачей (активна)' },
  { value: 'unactive', label: 'С задачей (неактивна)' },
  { value: 'tasked', label: 'Есть задача' },
  { value: 'untasked', label: 'Без задачи' },
];

export const WINNER_OPTIONS = [
  { value: '', label: 'Все победители' },
  { value: 'bot', label: 'Бот' },
  { value: 'human', label: 'Человек' },
  { value: 'other', label: 'Не наша' },
  { value: 'unknown', label: 'Неизвестно' },
];

export function formatDate(value, withYear = false) {
  if (!value) return EMPTY_VALUE;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return EMPTY_VALUE;
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    ...(withYear ? { year: 'numeric' } : {}),
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDateOnly(value) {
  if (!value) return EMPTY_VALUE;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return EMPTY_VALUE;
  return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' });
}

export function formatMoney(value) {
  if (typeof value !== 'number') return EMPTY_VALUE;
  return value.toLocaleString('ru-RU');
}

export function normalizeValue(value) {
  if (value === null || value === undefined) return EMPTY_VALUE;
  const normalized = String(value).trim().replace(/\s+/g, ' ');
  return normalized || EMPTY_VALUE;
}

export function titleCase(value) {
  const normalized = normalizeValue(value);
  if (normalized === EMPTY_VALUE) return normalized;
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
}

export function getPoints(order) {
  return order?.route?.points || [];
}

export function getLoadingPoint(order) {
  return getPoints(order)[0];
}

export function getDestinationPoint(order) {
  const points = getPoints(order);
  return points[points.length - 1];
}

export function getExtraLoadingCount(order) {
  const points = getPoints(order);
  if (points.length <= 2) return 0;
  return points.slice(1, -1).filter((p) => p.operation_type !== 'unloading').length;
}

export function getExtraUnloadingCount(order) {
  const points = getPoints(order);
  if (points.length <= 2) return 0;
  return points.slice(1, -1).filter((p) => p.operation_type === 'unloading').length;
}

export function formatCargo(order) {
  const list = order?.cargo?.list;
  if (!Array.isArray(list) || list.length === 0) return EMPTY_VALUE;
  const counts = new Map();
  list.forEach((item) => counts.set(item, (counts.get(item) || 0) + 1));
  return Array.from(counts.entries())
    .map(([item, count]) => (count > 1 ? `${item} (x${count})` : item))
    .join(', ');
}

export function getStatusMeta(order) {
  const status = order?.context?.status;
  return BIDDING_STATES.find((s) => s.value === status) || { value: status, label: status || EMPTY_VALUE, color: '#adb5bd' };
}

export function getCostMeta(order) {
  const start = order?.cost?.start;
  const last = order?.cost?.last;
  return {
    startWithoutNds: start?.without_nds ?? null,
    startWithNds: start?.with_nds ?? null,
    lastWithoutNds: last?.without_nds ?? null,
    lastWithNds: last?.with_nds ?? null,
    lastRank: last?.rank ?? null,
    lastFromBot: last?.from_bot ?? null,
  };
}

export function getWinnerMeta(order) {
  if (order?.context?.status !== 'WON') {
    return { text: EMPTY_VALUE, className: 'winner-none' };
  }

  const last = order?.cost?.last;
  if (!last) {
    return { text: '❔ Неизвестно', className: 'winner-unknown' };
  }

  if (last.own !== true) {
    return { text: 'Не наша', className: 'winner-other' };
  }

  return last.from_bot
    ? { text: '🤖 Бот', className: 'winner-bot' }
    : { text: '👤 Человек', className: 'winner-human' };
}

export function getWinnerValue(order) {
  const className = getWinnerMeta(order).className;
  if (className === 'winner-bot') return 'bot';
  if (className === 'winner-human') return 'human';
  if (className === 'winner-other') return 'other';
  if (className === 'winner-unknown') return 'unknown';
  return '';
}

export function formatCostRange(order) {
  const cost = getCostMeta(order);
  if (cost.lastWithoutNds != null) return formatMoney(cost.lastWithoutNds);
  if (cost.startWithoutNds != null) return formatMoney(cost.startWithoutNds);
  return EMPTY_VALUE;
}

export function getTaskMeta(order) {
  const task = order?.context?.task;
  if (!task) return { active: false, state: 'none', value: null, text: EMPTY_VALUE };
  const active = task.active === true;
  const value = typeof task.value === 'number' ? task.value : null;
  return {
    active,
    state: active ? 'active' : 'inactive',
    value,
    text: value != null ? formatMoney(value) : EMPTY_VALUE,
  };
}

export function formatOrderSummary(order) {
  const loading = getLoadingPoint(order);
  const destination = getDestinationPoint(order);
  const status = order?.context?.status || '';
  const cells = [
    normalizeValue(order?.meta?.trip_id),
    status,
    formatDate(loading?.planed_date),
    normalizeValue(loading?.city_name).toUpperCase(),
    normalizeValue(destination?.city_name).toUpperCase(),
    normalizeValue(order?.veh?.type),
    formatCostRange(order),
    normalizeValue(order?.meta?.service_name),
  ];
  return cells.filter((cell) => cell !== EMPTY_VALUE).join(' ');
}

function normalizeKey(value) {
  return value?.trim?.().toLowerCase?.() || 'unknown';
}

function getDateKey(value) {
  if (!value) return 'unknown';
  const match = String(value).match(/^\d{4}-\d{2}-\d{2}/)?.[0];
  return match || String(value).slice(0, 10);
}

function getHighlightKey(order, mode) {
  const loading = getLoadingPoint(order);
  switch (mode) {
    case 'platform':
      return normalizeKey(order?.meta?.service_name);
    case 'status':
      return normalizeKey(order?.context?.status);
    case 'departureCity':
      return normalizeKey(loading?.city_name);
    case 'departureDay':
      return getDateKey(loading?.planed_date);
    case 'source':
      return normalizeKey(order?.meta?.client_name);
    case 'simple':
      return 'simple';
    default:
      return null;
  }
}

export function getHighlightIndexes(orders, mode) {
  if (mode === 'simple') return orders.map((_, index) => index);
  let previousKey = null;
  let currentIndex = -1;
  return orders.map((order) => {
    const key = getHighlightKey(order, mode);
    if (!key) { previousKey = null; return null; }
    if (key !== previousKey) {
      currentIndex = (currentIndex + 1) % 12;
      previousKey = key;
    }
    return currentIndex;
  });
}

export function nextSorts(sorts, field, shiftKey = false) {
  const currentSorts = Array.isArray(sorts) && sorts.length ? sorts : DEFAULT_SORTS;
  const index = currentSorts.findIndex((item) => item.field === field);
  if (!shiftKey) {
    const dir = index === 0 && currentSorts[0].dir === 1 ? -1 : 1;
    return [{ field, dir }];
  }
  if (index === -1) return [...currentSorts, { field, dir: 1 }];
  return currentSorts.map((item, i) => (
    i === index ? { ...item, dir: item.dir === 1 ? -1 : 1 } : item
  ));
}

export function sortMeta(sorts, field) {
  const index = (sorts || []).findIndex((item) => item.field === field);
  if (index === -1) return { active: false, label: '' };
  const sort = sorts[index];
  const arrow = sort.dir === 1 ? '\u2191' : '\u2193';
  return { active: true, label: `${arrow}${index + 1}` };
}
